/**
 * Stories SF-CHAT-9.4/9.5 — respostas rápidas oferecidas pelo servidor.
 *
 * O servidor manda só ids de um conjunto fechado; rótulo e texto enviado são
 * daqui. Id desconhecido é ignorado: nada que o modelo escreva vira botão.
 * `trocar_empresa` não envia mensagem: abre o seletor de empresa da tela, que
 * pede ao app um grant novo para a empresa escolhida.
 */

export type QuickReply =
  | { kind: "message"; label: string; message: string }
  | { kind: "switch_company"; label: string; message?: undefined };

export const QUICK_REPLIES: Record<string, QuickReply> = {
  ver_contas_a_pagar: { kind: "message", label: "Contas a pagar", message: "Quais minhas contas a pagar?" },
  ver_contas_a_receber: { kind: "message", label: "Contas a receber", message: "Quais minhas contas a receber?" },
  ver_vencidas_a_pagar: { kind: "message", label: "Contas a pagar vencidas", message: "Quais contas a pagar estão vencidas?" },
  ver_saldos: { kind: "message", label: "Saldos bancários", message: "Qual o saldo das minhas contas bancárias?" },
  trocar_empresa: { kind: "switch_company", label: "Trocar de empresa" },
};

const MAX_BUTTONS = 6;

export function parseQuickReplies(raw: unknown): string[] {
  if (!raw || typeof raw !== "object") return [];
  const chunk = raw as { type?: unknown; options?: unknown };
  if (chunk.type !== "quick_replies" || !Array.isArray(chunk.options)) return [];
  const ids: string[] = [];
  for (const option of chunk.options) {
    if (typeof option !== "string" || !Object.prototype.hasOwnProperty.call(QUICK_REPLIES, option)) continue;
    if (!ids.includes(option)) ids.push(option);
    if (ids.length === MAX_BUTTONS) break;
  }
  return ids;
}
